var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"row",staticStyle:{"width":"100%"}},_vm._l((_vm.colSpan),function(c,index){return _c('el-col',{key:index,staticClass:"col",class:{'dotted-line': _vm.line},attrs:{"span":c}},[_vm._t(index)],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }